module.exports = __webpack_public_path__ + "img/v2_favourites_empty.bdf0b41a.svg";